module.exports = __webpack_public_path__ + "img/win.a90fda15.png";